import { useContext, useMemo } from "react";
import { useLocalization } from "@fluent/react";
import Account from "byzantine/src/Account";
import AccountContext from "../../../../contexts/AccountContext";
import LoanSelector from "../../LoanSelector";
import type { LoanPaymentFormType } from "../types";

interface LoanSelectorSectionProps {
  form: LoanPaymentFormType;
}

const LoanSelectorSection = ({ form }: LoanSelectorSectionProps) => {
  const { l10n } = useLocalization();
  const { accounts } = useContext(AccountContext) as { accounts: Account[] };

  const loanAccounts = useMemo(
    () =>
      accounts.filter(
        (a: Account) =>
          (a.isInternalLoan() && a.isValidTransferDestination()) ||
          a.isPayableByCard()
      ),
    [accounts]
  );

  const handleLoanChange = (value: unknown) => {
    form.setFieldValue("toAccountId", value, true);
  };

  return (
    <div style={{ marginBottom: "var(--space-s)" }}>
      <LoanSelector
        loans={loanAccounts}
        label={l10n.getString("loan-paydown-loan-selector-label")}
        value={form.values.toAccountId}
        onChange={handleLoanChange}
        error={
          form.touched.toAccountId && form.errors.toAccountId
            ? String(form.errors.toAccountId)
            : undefined
        }
      />
    </div>
  );
};

export default LoanSelectorSection;
